import path from "node:path";
import { downloadImage, getFilenameFromUrl, success } from "@iflyrpa/share";

import type { PublishAction, Source } from "./index";

const sourceText: Record<Source, string> = {
    ai: "内容由AI生成",
    official: "素材来源官方媒体/网络新闻",
    fictional: "内容剧情演绎，仅供娱乐",
    personal: "个人观点，仅供参考",
};

export const rpaAction: PublishAction = async (task, params) => {
    const commonCookies = {
        path: "/",
        secure: true,
        domain: "mp.weixin.qq.com",
        url: "https://mp.weixin.qq.com",
        httpOnly: true,
    };

    const page = await task.createPage({
        show: task.debug,
        url:
            params.url ||
            `https://mp.weixin.qq.com/cgi-bin/appmsg?t=media/appmsg_edit_v2&action=edit&isNew=1&type=77&createType=8&token=${params.token}&lang=zh_CN`,
        cookies: params.cookies?.map((it) => ({ ...it, ...commonCookies })) || [],
    });

    const tmpCachePath = task.getTmpPath();

    // 0. 判断是否登录
    try {
        await page.waitForSelector("#editor_pannel");
    } catch (_error) {
        return { code: 500, message: "登录失效", data: page.url() };
    }

    const container = page.locator("#editor_pannel");

    // 1. 添加图片
    if (params.banners && params.banners.length > 0) {
        const images = await Promise.all(
            params.banners.map((url) => {
                const fileName = getFilenameFromUrl(url);
                return downloadImage(url, path.join(tmpCachePath, fileName));
            }),
        );

        // 选择文件
        const fileChooserPromise = page.waitForEvent("filechooser");
        await container.locator(".image-selector__add").hover();
        await container
            .locator(".image-selector__add .pop-opr__list .pop-opr__item")
            .filter({ hasText: "本地上传" })
            .click();
        const fileChooser = await fileChooserPromise;
        await fileChooser.setFiles(images);
    }

    // 2. 标题
    const titleInstance = page.locator("#js_title_main textarea#title");
    await titleInstance.click();
    await titleInstance.fill(params.title);

    // 3. 正文
    const descInstance = page.locator("#guide_words_main .ProseMirror");
    await descInstance.click();
    await descInstance.fill(params.content);

    // 4. 来源
    if (params.source) {
        await container.locator("#js_claim_source_area .js_claim_source_desc").click();
        await page
            .locator(".popover_article_claim_source .frm_radio_item label")
            .filter({ hasText: sourceText[params.source] })
            .click();
    }

    // 5. 等待所有图片上传完成
    if (params.banners && params.banners.length > 0) {
        await page.waitForSelector("#editor_pannel .image-selector .image-selector__preview");
    }

    // 6. 保存
    if (params.draft) {
        await container.locator("#bottom_main #js_submit button").click();
    } else {
        await container.locator("#bottom_main #js_send button").click();
    }

    return success("");
};
